import { render, staticRenderFns } from "./triggers.vue?vue&type=template&id=b9ea35c2"
import script from "./triggers.vue?vue&type=script&lang=js"
export * from "./triggers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports